import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import InboundForm from "../../organisms/Inventory/InboundForm.tsx";
import InboundFormNoPO from "../../organisms/Inventory/InboundFormNoPO.tsx";

interface InboundTypeSelectorProps {
  onSubmit: () => void;
  id?: number;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`inbound-tabpanel-${index}`}
      aria-labelledby={`inbound-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `inbound-tab-${index}`,
    'aria-controls': `inbound-tabpanel-${index}`,
  };
}

const InboundTypeSelector: React.FC<InboundTypeSelectorProps> = ({ onSubmit, id }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="inbound type tabs">
          <Tab label="Con Orden de Compra" {...a11yProps(0)} />
          <Tab label="Sin Orden de Compra" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <InboundForm onSubmit={onSubmit} id={id} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <InboundFormNoPO onSubmit={onSubmit} id={id} />
      </TabPanel>
    </Box>
  );
};

export default InboundTypeSelector;
